/**
 * Returns true if the code is being run on server side.
 * Should be used instead of deprecated process.browser check.
 * source: https://github.com/vercel/next.js/issues/5354#issuecomment-520305040
 * @returns {boolean}
 */
export const isSSR = (): boolean => typeof window === 'undefined'
